module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av392-cdc36708c1142f3c2a7424bf7fda5cef.jpg";